/**
 * @author Fernando Ruano
 * @file routes.js
 * @description Roles routes
 */

// Pages
import StepOne from '@nephro/pages/PatientRegistration/StepOne';
import StepTwo from '@nephro/pages/PatientRegistration/StepTwo';
import StepThree from '@nephro/pages/PatientRegistration/StepThree';
import StepFour from '@nephro/pages/PatientRegistration/StepFour';

const pathStart = '/registration';
const routes = [
  {
    path: `${pathStart}/stepOne`,
    isProtected: false,
    component: StepOne,
    exact: true
  },
  {
    path: `${pathStart}/stepTwo`,
    isProtected: false,
    component: StepTwo,
    exact: true
  },
  {
    path: `${pathStart}/stepThree`,
    isProtected: false,
    component: StepThree,
    exact: true
  },
  {
    path: `${pathStart}/stepFour`,
    isProtected: false,
    component: StepFour,
    exact: true
  },
  { redirect: true, from: '/registration', to: `${pathStart}/stepOne` }
];

export default routes;
